import React, { MutableRefObject, useRef } from 'react';
import { MAP_HEIGHT } from 'constants/styled.contants';
import { FuelTypography } from '@frete.com/fuel-react';
import { useMapLoadedStatus } from 'hooks/useMapLoadedStatus';
import { ZOOM_MAX_LEVEL, ZOOM_MIN_LEVEL } from 'constants/profile';
import { MapContainerPropsInterface } from './types';
import Map from './Map';

import * as Styled from './styled';

const MapContainer = ({ markers }: MapContainerPropsInterface) => {
  const containerRef: MutableRefObject<HTMLDivElement | null> = useRef(null);
  const { isLoaded, zoomLevel } = useMapLoadedStatus();

  const isZoomMinDisabled = zoomLevel === ZOOM_MIN_LEVEL;
  const isZoomMaxDisabled = zoomLevel === ZOOM_MAX_LEVEL;

  return (
    <Styled.ContainerMap
      data-testid="map-container"
      ref={containerRef}
      isLoaded={isLoaded}
      $zoomMaxDisabled={isZoomMaxDisabled}
      $zoomMinDisabled={isZoomMinDisabled}
    >
      <Map markers={markers} width={containerRef?.current?.offsetWidth} height={MAP_HEIGHT} />
      {markers[0].lastLocation.isApproximated && (
        <FuelTypography size="caption" weight="medium" spacingTop={4} color="neutral-default">
          Localização aproximada com base no endereço de internet do motorista.
        </FuelTypography>
      )}
    </Styled.ContainerMap>
  );
};

export default MapContainer;
